export interface PhysicalRecord {
  recordId: string;
  availability: string;
  holdInfo: string;
  libraryName: string;
  previousHolds: string;
  returnDate: string;
  [key: string]: string;
}

export interface FascicleRecord {
  recordId: string;
  year: string;
  number: string;
  link: string;
}

export interface FasciclesByYear {
  year: string;
  items: FascicleItem[];
}

export interface FascicleItem {
  recordId: string;
  number: string;
  link: string;
}

export interface DescendientesRecord {
  recordId: string;
  title: string;
}

export interface PhysicalRecordResult {
  descendientesInfoList: DescendientesRecord[];
  generalInfoList: PhysicalRecord[];
  physicalInfoFasciclesList: FascicleRecord[];
  upperLevelRecordId: string;
  upperLevelTitle: string;
}

export enum HoldStatus {
  AVAILABLE = 'AVAILABLE',
  EXCLUDED_FROM_HOLD = 'EXCLUDED_FROM_HOLD',
  ALREADY_HELD = 'ALREADY_HELD',
}
